import { ReactElement } from 'react';
import { HiOutlineChevronDown } from 'react-icons/hi2';

interface AccordionIconProps {
  show: boolean;
}

export function AccordionIcon(props: AccordionIconProps): ReactElement {
  const { show } = props;
  return (
    <HiOutlineChevronDown
      className={`cr-size-5 cr-stroke-[3px]
              cr-transition-transform cr-duration-[300ms] ${show && 'cr-rotate-180'}`}
    />
  );
}

export default AccordionIcon;
